import React, { Component } from 'react';
import CoinTable from "./CoinTable";
import TopLists from "./TopLists";
import Search from "./Search";
import {Desktop} from "./Responsive";
import SearchResults from "./SearchResults";

class CoinList extends Component {

    componentWillUpdate() {
        document.title = "CoinGrasp";
    }

    render() {
        return (
            <div className="cg-coin-list">
                <div className="cg-searchfield-container box-shadow">
                    <Search {...this.props} />

                    <SearchResults {...this.props} />
                </div>

                <CoinTable {...this.props}/>
                <Desktop>
                    <div className="top-list-container col-lg-4">
                        <TopLists { ...this.props} />
                    </div>
                </Desktop>
            </div>
        );
    }
}

export default CoinList;



// WEBPACK FOOTER //
// ./src/CoinList.js